<div
  [ngClass]="
    reviewState === reviewStates.ReadOnly
      ? 'mt-30 section-label'
      : 'section-label'
  "
>
  <ng-container
    class="section-sub-label"
    *ngIf="reviewState !== reviewStates.ReadOnly"
    >Personal Details</ng-container
  >
  <span class="review_edit-area">
    <ng-container *ngIf="reviewState === reviewStates.ReadOnly">
      <a mat-button target="_blank" class="buttonLink" (click)="editDetails()">
        <img src="assets/images/edit-icon.svg" alt="Edit employment details" />
        Edit
      </a>
    </ng-container>
    <ng-container *ngIf="reviewState === reviewStates.Edit">
      <a
        role="button"
        mat-button
        target="_blank"
        tabindex="0"
        (keyup.space)="save()"
        (keyup.enter)="save()"
        class="buttonLink"
        (click)="save()"
        >Save</a
      >
      <a
        role="button"
        mat-button
        target="_blank"
        tabindex="0"
        (keyup.space)="cancel()"
        (keyup.enter)="cancel()"
        class="buttonLink"
        (click)="cancel()"
        >Cancel</a
      >
    </ng-container>
  </span>
</div>
<div>
  <div *ngIf="reviewState !== reviewStates.ReadOnly" class="subtitle-margin">
    <div class="legal-details">
      This should be your legal name and information as it appears on your
      government-issued ID.
    </div>
  </div>
  <ng-container *ngIf="reviewState !== reviewStates.ReadOnly">
    <div class="required-indicator">* Required Fields</div>
  </ng-container>
  <form [formGroup]="invitationForm" class="clear-right">
    <div
      [fxLayout]="reviewState === reviewStates.ReadOnly ? 'column' : 'row'"
      fxLayout.xs="column"
      fxLayoutAlign="space-between stretch"
      [fxLayoutGap]="reviewState !== reviewStates.ReadOnly ? '10px' : ''"
    >
      <ng-container
        class="read-only-label"
        *ngIf="reviewState === reviewStates.ReadOnly"
      >
        <div fxFlex="50" fxLayout="row" fxLayoutAlign="space-between end">
          <mat-label-tooltip>Account</mat-label-tooltip>
          <mat-label class="read-only-label" data-dd-privacy="mask">{{
            account
          }}</mat-label>
        </div>
      </ng-container>
      <ng-container *ngIf="reviewState === reviewStates.ReadOnly">
        <mat-divider></mat-divider>
      </ng-container>
      <div
        fxFlex="50"
        [fxLayout]="reviewState === reviewStates.ReadOnly ? 'row' : 'column'"
        [fxLayoutAlign]="
          reviewState === reviewStates.ReadOnly
            ? 'space-between end'
            : 'end start'
        "
        fxLayoutGap="5px"
      >
        <mat-label-tooltip
          [showToolTip]="reviewState != reviewStates.ReadOnly"
          id="firstName-label"
          >{{ reviewState !== reviewStates.ReadOnly ? "* " : ""
          }}<label for="firstName">First Name</label>
        </mat-label-tooltip>
        <ng-container
          *ngIf="reviewState != reviewStates.ReadOnly"
          class="form-input"
        >
          <mat-form-field appearance="outline">
            <input
              id="firstName"
              maxlength="40"
              formControlName="firstName"
              autocomplete="given-name"
              data-dd-privacy="mask-user-input"
              matInput
              required
            />
            <mat-error>{{ this.getFieldError("firstName") }}</mat-error>
          </mat-form-field>
        </ng-container>
        <ng-container
          class="read-only-label"
          *ngIf="reviewState === reviewStates.ReadOnly"
        >
          <mat-label
            for="firstName"
            class="read-only-label"
            data-dd-privacy="mask"
            >{{ getFormControlValue("firstName") }}</mat-label
          >
        </ng-container>
      </div>
      <ng-container *ngIf="reviewState === reviewStates.ReadOnly">
        <mat-divider></mat-divider>
      </ng-container>
      <div
        fxFlex="50"
        [fxLayout]="reviewState === reviewStates.ReadOnly ? 'row' : 'column'"
        [fxLayoutAlign]="
          reviewState === reviewStates.ReadOnly
            ? 'space-between end'
            : 'end start'
        "
        fxLayoutGap="5px"
      >
        <mat-label-tooltip
          [showToolTip]="reviewState != reviewStates.ReadOnly"
          id="lastName-label"
          >{{ reviewState !== reviewStates.ReadOnly ? "* " : ""
          }}<label for="lastName">Last Name</label>
        </mat-label-tooltip>
        <ng-container
          *ngIf="reviewState != reviewStates.ReadOnly"
          class="form-input"
        >
          <mat-form-field appearance="outline">
            <input
              matInput
              id="lastName"
              formControlName="lastName"
              maxlength="40"
              autocomplete="family-name"
              data-dd-privacy="mask-user-input"
              required
            />
            <mat-error>{{ this.getFieldError("lastName") }}</mat-error>
          </mat-form-field>
        </ng-container>
        <ng-container
          class="read-only-label"
          *ngIf="reviewState === reviewStates.ReadOnly"
        >
          <mat-label
            class="read-only-label"
            for="lastName"
            data-dd-privacy="mask"
            >{{ getFormControlValue("lastName") }}</mat-label
          >
        </ng-container>
      </div>
    </div>
    <ng-container *ngIf="reviewState === reviewStates.ReadOnly">
      <mat-divider></mat-divider>
    </ng-container>
    <div
      [fxLayout]="reviewState === reviewStates.ReadOnly ? 'column' : 'row'"
      fxLayout.xs="column"
      fxLayoutAlign="space-between stretch"
      [fxLayoutGap]="reviewState !== reviewStates.ReadOnly ? '10px' : ''"
    >
      <div
        fxFlex="50"
        [fxLayout]="reviewState === reviewStates.ReadOnly ? 'row' : 'column'"
        [fxLayoutAlign]="
          reviewState === reviewStates.ReadOnly
            ? 'space-between end'
            : 'end start'
        "
        fxLayoutGap="5px"
      >
        <mat-label-tooltip
          [showToolTip]="reviewState != reviewStates.ReadOnly"
          id="birthDate-label"
          >{{ reviewState !== reviewStates.ReadOnly ? "* " : "" }}
          <label for="birthDate">Date of Birth (MM/DD/YYYY)</label>
        </mat-label-tooltip>
        <ng-container
          *ngIf="reviewState != reviewStates.ReadOnly"
          class="form-input"
        >
          <mat-form-field appearance="outline">
            <input
              [min]="minDate"
              [max]="maxDate"
              matInput
              [matDatepicker]="dp"
              id="birthDate"
              formControlName="birthDate"
              (keyup)="onDateKeyUp($event)"
              autocomplete="bday"
              required
              data-dd-privacy="mask-user-input"
            />
            <mat-error>{{ this.getFieldError("birthDate") }}</mat-error>
            <mat-hint style="display: none">date format: (MM/DD/YYYY)</mat-hint>
            <mat-datepicker #dp></mat-datepicker>
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
          </mat-form-field>
        </ng-container>
        <ng-container
          class="read-only-label"
          *ngIf="reviewState === reviewStates.ReadOnly"
        >
          <mat-label
            for="birthDate"
            class="read-only-label"
            data-dd-privacy="mask"
            >{{
              getFormControlValue("birthDate") | date : "MM/dd/YYYY"
            }}</mat-label
          >
        </ng-container>
      </div>
      <ng-container *ngIf="reviewState === reviewStates.ReadOnly">
        <mat-divider></mat-divider>
      </ng-container>
      <div
        fxFlex="50"
        [fxLayout]="reviewState === reviewStates.ReadOnly ? 'row' : 'column'"
        [fxLayoutAlign]="
          reviewState === reviewStates.ReadOnly
            ? 'space-between end'
            : 'end start'
        "
        fxLayoutGap="5px"
      >
        <mat-label-tooltip [showToolTip]="false" id="email-label"
          >{{ reviewState !== reviewStates.ReadOnly ? "* " : ""
          }}<label for="email">Personal Email Address</label></mat-label-tooltip
        >
        <div *ngIf="reviewState != reviewStates.ReadOnly" class="form-input">
          <mat-form-field appearance="outline">
            <input
              matInput
              type="email"
              id="email"
              formControlName="emailAddress"
              autocomplete="email"
              data-dd-privacy="mask-user-input"
            />
            <mat-error>{{ this.getFieldError("emailAddress") }}</mat-error>
            <mat-error *ngIf="invitationForm.get('email')?.hasError('required')"
              >Email is required</mat-error
            >
            <mat-error
              *ngIf="invitationForm.get('email')?.hasError('duplicated')"
              >Primary and Co-Applicant emails must not match.</mat-error
            >
          </mat-form-field>
        </div>
        <ng-container
          class="read-only-label"
          *ngIf="reviewState === reviewStates.ReadOnly"
        >
          <mat-label
            class="read-only-label"
            for="email"
            data-dd-privacy="mask"
            >{{ getFormControlValue("emailAddress") }}</mat-label
          >
        </ng-container>
      </div>
      <ng-container *ngIf="reviewState === reviewStates.ReadOnly">
        <mat-divider></mat-divider>
      </ng-container>
    </div>
  </form>
</div>
<br />
